import { GridManager } from './blocks-grid';
class TabsManager {
    constructor() {
        $(document).on('click', '.js-TabBtn', (e) => {
            const elem = $(e.target);
            this.focusTab(elem.data('tab-group'), elem.data('related-tab-id'));
            setTimeout(() => {
                this.resize(elem);
            }, 1);
            return false;
        });
    }
    focusTab(tabGroup, tabItem) {
        if (!tabGroup || !tabItem)
            return;
        const selectedContent = $(`.js-TabContent[data-tab-group="${tabGroup}"][data-tab-id="${tabItem}"]`);
        const otherContents = $(`.js-TabContent[data-tab-group="${tabGroup}"]:not([data-tab-id="${tabItem}"])`);
        otherContents.removeClass('Tab_Content-Open');
        selectedContent.addClass('Tab_Content-Open');
    }
    resize(elem) {
        const parentGrid = GridManager.getGridFromElement(elem);
        if (parentGrid) {
            parentGrid.resize();
        }
    }
}
const tabsManager = new TabsManager();
export { TabsManager, tabsManager };
